<template>
  <div class="pageContol">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">系统管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">考场管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">{{ lastPageData.roomId ? '编辑' : '新增' }}</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-form ref="ruleForm" class="ruleForm" :rules="rules" :model="ruleForm" label-width="100px" size="small"
              style="width: 500px;">
              <el-form-item label="考场名称" prop="officerName">
                <el-input type="text" v-model="ruleForm.roomName" clearable placeholder="请输入考场名称" />
              </el-form-item>
              <el-form-item label="作业类别:" prop="workCategory">
                <el-select size="small" v-model="ruleForm.workCategory" clearable placeholder="请选择作业类别">
                  <el-option v-for="item in workCategoryList" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button class="bgc-bv" @click="$router.back()">取 消</el-button>
                <el-button class="bgc-bv" @click="sureData">确 定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "systemManage_room_mgt",
  data() {
    return {
      // 上个页面的数据
      lastPageData: {
        roomId: "", // 考官id
      },
      // 基本信息
      ruleForm: {
        roomName: "", // 考场名称
        workCategory: "", // 作业类别
      },
      // 基本信息 - 数据校验
      rules: {
        roomName: [
          { required: true, trigger: "blur", message: "请输入考场名称" }
        ],
        workCategory: [
          { required: true, trigger: "change", message: "请选择作业类别" }
        ],
      },
      workCategoryList: [], // 作业类别 - 下拉数据
    };
  },
  created() {
    this.lastPageData.roomId = this.$route.query?.roomId ?? "";
    this.getDictionary();
    if (this.lastPageData.roomId) {
      this.getDetail();
    }
  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 详情
    getDetail() {
      this.$post("/biz/v2/room/info", {
        roomId: this.lastPageData.roomId
      }, 3000, true, 10).then((res) => {
        this.ruleForm = { ...this.ruleForm, ...res.data }
      });
    },
    // 获取 - 字典
    getDictionary() {
      // 作业类别
      let workCategory = this.$setDictionary("PA_WORK_CATEGORY", "list");
      for (const key in workCategory) {
        this.workCategoryList.push({
          value: key,
          label: workCategory[key],
        });
      }
    },
    // 保存 - 新增&编辑
    sureData() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let cData = {
            ...this.ruleForm,
          }
          let url = '';
          if (this.lastPageData.roomId) {
            url = '/biz/v2/room/modify'
          } else {
            url = '/biz/v2/room/insert'
          }
          this.$post(url, cData, 3000, true, 10)
            .then((res) => {
              this.$message.success('操作成功')
              this.$router.back();
            })
            .catch((err) => {
              return;
            });
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.ruleForm {
  .fromTitle {
    font-size: 18px;
    margin-bottom: 20px;
  }
}
</style>